import type { FlightCard } from '@/src/types/flight'

export function getEffectivePrice({
    card,
    shouldShowMultiAirlinePrices,
    isPerPaxPricingEnabled
}: {
    card: FlightCard
    shouldShowMultiAirlinePrices: boolean
    isPerPaxPricingEnabled: boolean
}): number {
    const { pr, multiAirlinePrice, totalAdultFare } = card.priceBreakup || ({} as any)
    const price = shouldShowMultiAirlinePrices
        ? multiAirlinePrice || 0
        : isPerPaxPricingEnabled
          ? totalAdultFare || 0
          : pr || 0
    return Number.isFinite(price) ? Number(price) : 0
}

